import React, { FC, ReactNode } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { BoxIcon } from '@systemeio/ui/icons'

type Props = {
  additionalChild?: ReactNode
}

export const DigitalProductBase: FC<Props> = ({ additionalChild }) => {
  const { t } = useLocoTranslation()
  return (
    <div className={'flex flex-col gap-3'}>
      <div className={'flex items-center justify-between'}>
        <div className="text-brand-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]">
          <BoxIcon />
          <span>{t('dashboard.funnel.configuration.offer.digital_product')}</span>
        </div>
        {additionalChild}
      </div>
      <span className="text-sm font-normal">
        {t('dashboard.funnel.configuration.offer.digital_product_description')}
      </span>
    </div>
  )
}
